import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import { Push as FaqPush } from 'imports/help/ui/components/Link';
import { useRouter } from 'next/router';
import env from '/env';
import { Push } from '/components/Link';
import { cookieParser, getJobTrackRoute } from '/lib/helpers';
import useIntl from '/imports/core/api/useIntl';
import useTracking from '/imports/core/hooks/useTracking';
import dynamic from 'next/dynamic';

const LoadingPlaceholder = () => <div></div>;
const RemoveLandingExperiment = dynamic(() => import('/imports/landing/ui/components/RemoveLandingExperiment'), {
  ssr: false,
});
const Homepage = dynamic(() => import('/imports/homepage/ui/pages/Homepage'), {
  ssr: true,
  loading: LoadingPlaceholder,
});
const HomepageV2 = dynamic(() => import('/imports/homepageV2/ui/pages/Homepage'), {
  ssr: true,
  loading: LoadingPlaceholder,
});
const HomepageV3 = dynamic(() => import('/imports/homepageV3/ui/pages/Homepage'), {
  ssr: true,
  loading: LoadingPlaceholder,
});
const isProd = env.NODE_ENV === 'production';

const LandingPage = ({ userIdentified, currentUser, host }) => {
  const router = useRouter();
  const { locale } = useIntl();
  const { trackEvent, resetTracking } = useTracking();

  const [isHydrated, setIsHydrated] = useState(false);
  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const ctaClick = (target) => {
    const { asPath } = router;

    if (host === 'resumedone' && isProd) {
      window.location.href = `https://theresumeranger.com/${locale}/onboard/start`;
      return;
    }

    const destinationV2 = userIdentified ? getJobTrackRoute(host, 'resumes').as : '/onboard/start';

    trackEvent('cta_click', { target });

    const queryString = {
      from: asPath,
    };

    Push(`/onboarding?${qs.stringify(queryString)}`, locale, destinationV2);
  };

  useEffect(() => {
    if (router.query.from === 'blog') {
      trackEvent('blog_exit_hack', { host });
    }

    if (router?.query?.reset) {
      resetTracking();
      Push('/', locale);
    }

    if (typeof window !== 'undefined') {
      const url = window.location.hostname;
      const help = url.split('.');

      if (help.includes('help') && window.location.pathname === '/builder') {
        FaqPush('/', locale);
      }

      window.onpageshow = function () {
        if (cookieParser().token && !userIdentified) {
          window.location.reload();
        }
      };
    }
  }, [router, locale, userIdentified, resetTracking, trackEvent, host]);

  if (!isHydrated) return null;
  const nestedProperties = {
    ctaClick,
    userIdentified,
    currentUser,
    page: router.query.page,
  };

  if (host === 'resumizeme') {
    return <HomepageV3 {...nestedProperties} />;
  }

  if (host === 'elegantcv') {
    return <Homepage {...nestedProperties} />;
  }

  return (
    <>
      <HomepageV2 {...nestedProperties} />
      <RemoveLandingExperiment />
    </>
  );
};

LandingPage.propTypes = {
  userIdentified: PropTypes.bool,
  locale: PropTypes.string,
  currentUser: PropTypes.object,
  host: PropTypes.string,
};

export default LandingPage;
